/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdTextProps, TdTitleProps, TdParagraphProps } from './type';

export const textDefaultProps: TdTextProps = {
  code: false,
  copyable: false,
  delete: false,
  disabled: false,
  ellipsis: false,
  italic: false,
  keyboard: false,
  mark: false,
  strong: false,
  underline: false,
};

export const titleDefaultProps: TdTitleProps = { ellipsis: false, level: 'h1' };

export const paragraphDefaultProps: TdParagraphProps = { ellipsis: false };
